import QrCodeIcon from '@mui/icons-material/QrCode'
import Chip from '@mui/material/Chip'
import React from 'react'

type Props = {
  serialNumber: string
}

const SerialNumberChip: React.FC<Props> = ({ serialNumber }) => (
  <Chip icon={<QrCodeIcon fontSize="small" />} label={serialNumber} size="small" sx={{ color: 'text.secondary' }} variant="outlined" />
)

export default SerialNumberChip
